import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getInstitutionDetailsApi,
  getCountDetailsApi,
  saveInstituionDetailsApi,
  singleInstitutionDetailApi,
  updateInstitutionDetailsApi,
  getSubscriptionApi, 
} from "../../apiservice/setting";

import { getCountryList, getCurrencyCodeWithName, convertCurrency } from "../../lib/currency";
import { getIndustries, getDays } from "../../lib/industries";

// 🟢 Fetch all institutions + merge counts like old UI
export const fetchInstitutions = createAsyncThunk(
  "adminDashboard/fetchInstitutions",
  async (_, { rejectWithValue }) => {
    try {
      const [instRes, countsRes] = await Promise.all([
        getInstitutionDetailsApi(),
        getCountDetailsApi({}),
      ]);

      const institutions = instRes.data.data || [];
      const counts = countsRes.data.data || {};

      return institutions.map((item) => {
        const userCount = counts.userCounts?.find((u) => u.id === item.id);
        const coreCount = counts.coreCounts?.find((c) => c.id === item.id);
        const baseCount = counts.baseCounts?.find((b) => b.id === item.id);
        const branchCount = counts.branchCounts?.find((br) => br.id === item.id);

        return {
          ...item,

          // ✅ merge usage counts safely
          used_user_count: userCount?.used_user_count ?? 0,
          used_core_count: coreCount?.used_core_count ?? 0,
          used_basic_count: baseCount?.used_basic_count ?? 0,
          used_branch_count: branchCount?.used_branch_count ?? 0,
        };
      });
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchSingleInstitution = createAsyncThunk(
  "adminDashboard/fetchSingleInstitution",
  async (id, { rejectWithValue }) => {
    try {
      const res = await singleInstitutionDetailApi({ id });
      return res.data.data[0];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const saveInstitution = createAsyncThunk(
  "adminDashboard/saveInstitution",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await saveInstituionDetailsApi(payload);
      return res.data;
    } catch (err) {
      
      const backendMessage =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message ||
        "Something went wrong";

      return rejectWithValue(backendMessage);
    }
  }
);

export const updateInstitution = createAsyncThunk(
  "adminDashboard/updateInstitution",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await updateInstitutionDetailsApi(payload);
      return res.data;
    } catch (err) {
      const backendMessage =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message ||
        "Something went wrong";

      return rejectWithValue(backendMessage);
    }
  }
);

export const fetchCountries = createAsyncThunk(
  "adminDashboard/fetchCountries",
  async (_, { rejectWithValue }) => {
    try {
      return getCountryList();
    } catch (err) {
      return rejectWithValue(err.message || "Failed to load countries");
    }
  }
);

export const fetchCurrencies = createAsyncThunk(
  "adminDashboard/fetchCurrencies",
  async (_, { rejectWithValue }) => {
    try {
      return getCurrencyCodeWithName();
    } catch (err) {
      return rejectWithValue(err.message || "Failed to load currencies");
    }
  }
);

export const fetchIndustries = createAsyncThunk(
  "adminDashboard/fetchIndustries",
  async (_, { rejectWithValue }) => {
    try {
      return getIndustries();
    } catch (err) {
      return rejectWithValue(err.message || "Failed to load industries");
    }
  }
);

export const fetchDays = createAsyncThunk(
  "adminDashboard/fetchDays",
  async (_, { rejectWithValue }) => {
    try {
      return getDays();
    } catch (err) {
      return rejectWithValue(err.message || "Failed to load days");
    }
  }
);

export const fetchSubscriptionModels = createAsyncThunk(
  "adminDashboard/fetchSubscriptionModels",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getSubscriptionApi();
      return res?.data?.data || []
    } catch (err) {
      return rejectWithValue(err.message || "Failed to load days");
    }
  }
);

// 🟢 Currency conversion
// export const fetchConversionRate = createAsyncThunk(
//   "adminDashboard/fetchConversionRate",
//   async ({ from, to }, { rejectWithValue }) => {
//     try {
//       const rate = await convertCurrency(from, to);
//       return { from, to, rate };
//     } catch (err) {
//       return rejectWithValue(err.message || "Failed to fetch conversion rate");
//     }
//   }
// );
